__turbopack_context__.v({
  "authActionsContainer": "MobileSideDrawer-module-scss-module__SxtfTG__authActionsContainer",
  "companySignUp": "MobileSideDrawer-module-scss-module__SxtfTG__companySignUp",
  "container": "MobileSideDrawer-module-scss-module__SxtfTG__container",
  "contentContainer": "MobileSideDrawer-module-scss-module__SxtfTG__contentContainer",
  "footerContainer": "MobileSideDrawer-module-scss-module__SxtfTG__footerContainer",
  "footerItem": "MobileSideDrawer-module-scss-module__SxtfTG__footerItem",
  "headerContainer": "MobileSideDrawer-module-scss-module__SxtfTG__headerContainer",
  "isDrawerVisible": "MobileSideDrawer-module-scss-module__SxtfTG__isDrawerVisible",
  "isOpen": "MobileSideDrawer-module-scss-module__SxtfTG__isOpen",
  "profileMenu": "MobileSideDrawer-module-scss-module__SxtfTG__profileMenu",
  "userInfoContainer": "MobileSideDrawer-module-scss-module__SxtfTG__userInfoContainer",
  "userMetaContainer": "MobileSideDrawer-module-scss-module__SxtfTG__userMetaContainer",
});
